export const fastGamesTextContent = {
  headingText: "More Games",
};
